import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme: any) => ({
  sidebarHeader: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    height: 64,
    gap: 15,
    padding: "16px",

    "& a": {
      color: theme.palette.text.primary,
      fontSize: "18px",
      textDecoration: "none",
      fontFamily: "Philosopher",
      fontWeight: 900,
    },
  },

  sidebarLogo: {
    width: 40,
  },

  sidebarNavLink: {
    textDecoration: "none",
    fontFamily: "Philosopher",
    fontWeight: 900,
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    gap: "8px",

    "& span": {
      fontFamily: "Philosopher",
      fontWeight: 900,
    },

    "&.active": {
      color: theme.palette.text.primary,
    },
  },

  sideBarConnectWalletBtn: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.background.lightGray,
    borderRadius: "12px",
    color: theme.palette.text.primary,

    "& span": {
      fontFamily: "Philosopher",
      fontWeight: 900,
    },
  },

  sidebarPaper: {
    backgroundColor: "rgb(23, 25, 26)",
    width: 240,
    minWidth: 240,
  },

  sideBar: {
    height: "100vh",
    width: 240,
    minWidth: 240,
    backgroundColor: "rgb(23, 25, 26)",
    display: "flex",
    flexDirection: "column",
    paddingTop: "120px",
    zIndex: 100,
    boxSizing: "border-box",
    overflowY: "auto",
    borderRight: "1px solid black",
  },

  navLinkIcon: {
    width: 20,
    height: 20,
  },

  navLinkText: {
    fontSize: 16,
    color: "grey",
    fontFamily: "Philosopher",
    fontWeight: 900,
    userSelect: "none",
  },

  navLinkGroup: {
    display: "flex",
    flexDirection: "column",
  },

  navLinkHeader: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    paddingRight: 12,
    fontFamily: "Philosopher",
    fontWeight: 900,
  },

  navLinkHeaderContent: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    paddingLeft: 20,
    flexGrow: 1,
  },

  navLinks: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 12,
    paddingBottom: 24,
  },

  navLink: {
    padding: 4,
    paddingLeft: 32,
    transition: "background-color 0.3s",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    "& p": {
      color: "white",
      fontFamily: "Philosopher",
      fontWeight: 900,
      fontSize: 16,
      textTransform: "none",
    },

    "&:hover": {
      backgroundColor: "rgb(33, 35, 37)",
    },
  },

  navLinkHeaderLine: {
    height: 1,
    width: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    marginTop: 0,
    maxWidth: 60,
  },

  nowBadge: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: 4,
    color: "rgb(90, 176, 95)",
    padding: "2px 8px",
    fontSize: 12,
    fontFamily: "Philosopher",
    fontWeight: 900,
  },

  timeBadge: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: 4,
    color: "rgb(141, 141, 141)",
    padding: "2px 8px",
    fontSize: 12,
    fontFamily: "Philosopher",
    fontWeight: 900,
  },

  botBadge: {
    backgroundColor: "rgba(0, 153, 255, 0.78)",
    borderRadius: 4,
    color: "rgb(255, 255, 255)",
    padding: "2px 8px",
    fontSize: 12,
    fontFamily: "Philosopher",
    fontWeight: 900,
  },

  badgeList: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginRight: "8px",
  },
}));
